/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

export type CompanyID = string;

export class Company {
	id: CompanyID = ''

	cocNumber: string = ''

	companyName: string = ''
}